import dateFormat from "dateformat";
export const timestempConvert = (value) => {
  if (!value) {
    return null;
  }
  return dateFormat(value * 1000, "dd/mm/yyyy");
};
